import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getReleaseById } from '../controllers/releaseController';

const ReleaseDetailView = () => {
  const { id } = useParams();
  const [release, setRelease] = useState(null);
  const navigate = useNavigate();

  var magazine_id = null;
  var magazineL = localStorage.getItem('magazine');
  if (magazineL) {
    magazine_id = JSON.parse(magazineL).magazine_id;
  }

  useEffect(() => {
    const params = {
      magazineId: magazine_id,
      releaseId: id
    };
    getReleaseById(params, setRelease);
  }, [id]);

  if (!release) return <p>Loading...</p>;

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title fw-semibold mb-4">Release Detail</h5>
          <div className="card">
            <div className="card-body">
              <div className="py-9">
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">ID: </h6>
                    <p className="mb-0">{release.id}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Display Name:</h6>
                    <p className="mb-0">{release.display_name}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Cover Image: </h6>
                    <p className="mb-0"><img src={`https://dittmagasin.no/resources/uploads/releases/images/${release.image}`} width={300} /></p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Introduction: </h6>
                    <p className="mb-0">{release.introduction}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Issued Date: </h6>
                    <p className="mb-0">{release.issued_date}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Publish Date: </h6>
                    <p className="mb-0">{release.publish_date}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Release Link: <Link className="btn btn-warning btn-sm btn-rounded" target='_blank' to={`${release.release_path}`}>View</Link> <span>You may need subscriber login to access releases</span> </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Created At: </h6>
                    <p className="mb-0">{release.created_at}</p>
                  </div>
                </div>
              </div>
              <div className="py-4 border-top">
                <button className="btn btn-sm btn-secondary me-2" onClick={() => navigate(-1)}>
                  Back
                </button>
                <button className="btn btn-sm btn-primary" onClick={() => navigate(`/releases/${id}/edit`)}>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseDetailView;
